<div class="tw-border-secondary-300 tw-mt-3 tw-rounded-md tw-border tw-bg-background tw-p-6">
  <h2 class="tw-mb-6 tw-text-xl tw-font-semibold">{{ "logInInitiated" | i18n }}</h2>

  <div class="tw-text-light">
    <p class="tw-mb-6">{{ "notificationSentDevice" | i18n }}</p>

    <p class="tw-mb-6">
      {{ "fingerprintMatchInfo" | i18n }}
    </p>
  </div>

  <div class="tw-mb-6">
    <h4 class="tw-font-semibold">{{ "fingerprintPhraseHeader" | i18n }}</h4>
    <p>
      <code>{{ passwordlessRequest?.fingerprintPhrase }}</code>
    </p>
  </div>

  <div class="tw-my-10" *ngIf="showResendNotification">
    <a [routerLink]="[]" disabled="true" (click)="startPasswordlessLogin()">{{
      "resendNotification" | i18n
    }}</a>
  </div>

  <hr />

  <div class="tw-mt-3 tw-text-light">
    {{ "loginWithDeviceEnabledInfo" | i18n }}
    <a routerLink="/login">{{ "viewAllLoginOptions" | i18n }}</a>
  </div>
</div>
